import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, SectionHeader } from './ui';

const StyledCareers = styled.section`
  ${sectionMargins()};
`;

const StyledHeader = styled(SectionHeader)`
  margin-bottom: 30px;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 50px;
  `}
`;

const StyledEmbed = styled.iframe`
  width: 100%;
  border: none;
`;

const Careers = ({ heading, text }) => (
  <StyledCareers>
    <Container>
      <StyledHeader heading={heading} text={text} />
      <StyledEmbed
        src="http://marcloudconsulting.bamboohr.com/jobs/embed2.php?version=1.0.0"
        height="480"
      ></StyledEmbed>
    </Container>
  </StyledCareers>
);

export default Careers;
